export interface IAssignCenterOpoRequest {
    centerId: number,
    shipToOpo: boolean
}
